import { atom } from "jotai";

export const socketAgentIdAtom = atom<number>();
